import React from "react";
import {Navigate, useParams} from "react-router-dom";

import {Spinner} from "../../atoms/spinner";
import {DocumentTitle} from "../../atoms/document-title";
import {Banner} from "../../atoms/banner";
import {useQuicksightCurrentUserDashboards} from "./hooks/useQuicksightCurrentUserDashboards";
import {ReportQuicksightDashboard} from "./reports/ReportQuicksightDashboard";
import {ReportingLayout} from "./reporting-layout";
import {menuSectionPath} from "./reporting-paths";

export const PageReportingDashboards = () => {
  const {sectionId} = useParams<{sectionId?: string}>();
  const {data = [], isFetched} = useQuicksightCurrentUserDashboards();

  if (!isFetched) {
    return (
      <ReportingLayout>
        <DocumentTitle title="Reside - Admin - Reporting | Dashboards" />
        <Spinner />
      </ReportingLayout>
    );
  }

  if (data.length === 0) {
    return (
      <ReportingLayout>
        <DocumentTitle title="Reside - Admin - Reporting | Dashboards" />
        <Banner title="No reports are available for this section.">
          <p>Please choose a different report from the left menu.</p>
        </Banner>
      </ReportingLayout>
    );
  }

  const dashboard =
    (sectionId && data.find(item => item.id === sectionId)) || undefined;

  if (!dashboard) {
    return (
      <Navigate
        to={menuSectionPath("analytics", "dashboards", data[0].id)}
        replace
      />
    );
  }

  return (
    <ReportingLayout>
      <DocumentTitle title="Reside - Admin - Reporting | Dashboards" />
      <ReportQuicksightDashboard id={dashboard.id} name={dashboard.name} />
    </ReportingLayout>
  );
};
